import { css } from '@inter-ikea-kompis/web-component';
import { Text } from '@ingka/common-styles-webc';
export default class LawLabelCardStyle {
    static getStyle(options) {
        const { color, spacing } = options.theme;
        return css `
			${Text.CSS}
			.container {
				display: flex;
				flex-direction: column;
				color: ${color.text.dark};
			}

			.message {
				margin-bottom: ${spacing.space100 / 16}rem;
			}

			img {
				width: 100%;

				& + img {
					margin-top: ${spacing.space100 / 16}rem;
				}
			}
		`;
    }
}
//# sourceMappingURL=LawLabelCardStyle.js.map